/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "Informazioni su";
var Access = "Accesso";
var Account = "Account";
var Actions = "Azioni";
var Active = "Attivo";
var Add = "Aggiungi";
var Address = "Indirizzo";
var Advanced = "Avanzate";
var Aliases = "Alias";
var all = "tutti";
var All = "Tutti";
var Apply = "Applica";
var April = "Aprile";
var Arbitrary = "Arbitrario";
var Assign = "Assegna";
var August = "Agosto";
var Back = "Indietro";
var Basic = "Base";
var BNPP_EU = "BNPP_EU";
var Cancel = "Annulla";
var Category = "Categoria";
var Classic = "Classic";
var Clear = "Cancella";
var CLI = "CLI";
var Close = "Chiudi";
var Clusters = "Cluster";
var code = "codice";
var Complete = "Completato";
var Completed = "Completato";
var Compliance = "Conformità";
var Compliant = "Conforme";
var Configuration = "Configurazione";
var Configure = "Configura";
var Confirm = "Conferma";
var Connect = "Connetti";
var Connected = "Connesso";
var Connecting = "Connessione";
var Containers = "Containers";
var Country = "Paese";
var Create = "Creazione";
var Created = "Creato";
var Creating = "Creazione";
var Critical = "Critico";
var Current = "Corrente";
var Custom = "Personalizzato";
var Dallas = "Dallas";
var Datacenter = "Datacenter";
var Datacenters = "Data center";
var December = "Dicembre";
var Delete = "Elimina";
var Deleting = "Eliminazione";
var Deploying = "Distribuzione";
var Disabled = "Disabilitato";
var Disconnect = "Disconnetti";
var Docs = "Documentazione";
var Documentation = "Documentazione";
var Done = "Fine";
var Download = "Scarica";
var Draft = "Bozza";
var Edit = "Modifica";
var Enabled = "Abilitato";
var Encryption = "Crittografia";
var End = "Fine";
var Enterprise = "Enterprise";
var Establish = "Definire";
var Expired = "Scaduto";
var Failed = "Non riuscito";
var February = "Febbraio";
var Filter = "Filtro";
var Filters = "Filtri";
var Finalizing = "Finalizzazione";
var Frankfurt = "Francoforte";
var Free = "Gratuito";
var Friday = "Venerdì";
var Geography = "Area geografica";
var Help = "Guida";
var hour = "ora";
var Hour = "Ora";
var hr = "ora";
var IAM = "IAM";
var ID = "ID";
var Images = "Immagini";
var Inactive = "Inattivo";
var Incomplete = "incompleto";
var Information = "Informazioni";
var Infrastructure = "Infrastruttura";
var Instance = "Istanza";
var Instances = "Istanze";
var Integrations = "Integrazioni";
var Invalid = "Non valido";
var January = "Gennaio";
var July = "Luglio";
var June = "Giugno";
var Key = "Chiave";
var Launch = "Avvia";
var Lite = "Lite";
var Loading = "Caricamento";
var Location = "Posizione";
var Locations = "Ubicazioni";
var Logging = "Registrazione";
var London = "Londra";
var March = "Marzo";
var May = "Maggio";
var Metro = "Area metropolitana";
var Minute = "Minuto";
var mo = "me";
var Monday = "Lunedì";
var Monitoring = "Monitoring";
var Month = "Mese";
var more = "altro";
var Name = "Nome";
var Namespace = "Namespace";
var Namespaces = "Namespace";
var Next = "Avanti";
var No = "No";
var None = "Nessuno";
var Normal = "Normale";
var Note = "Nota";
var Notification = "Notifica";
var November = "Novembre";
var Objects = "Oggetti";
var October = "Ottobre";
var Off = "Non attivo";
var OK = "OK";
var On = "Attivo";
var Open = "Apri";
var Osaka = "Osaka";
var Overview = "Panoramica";
var Packages = "Pacchetti";
var Pattern = "Modello";
var Pending = "In sospeso";
var Plan = "Piano";
var Premium = "Premium";
var Previous = "Precedente";
var Product = "Prodotto";
var Products = "Prodotti";
var Project = "Progetto";
var Projects = "Progetti";
var Property = "Proprietà";
var provided = "fornito";
var Provider = "Provider";
var Provisioning = "Provisioning";
var Ready = "Pronto";
var Refresh = "Aggiorna";
var region = "regione";
var Region = "Regione";
var Remove = "Rimuovi";
var Renew = "Rinnova";
var Repositories = "Repository";
var Requested = "Richiesto";
var Required = "Obbligatorio";
var Reservations = "Prenotazioni";
var Reset = "Reimposta";
var resources = "resources";
var Resources = "Risorse";
var Results = "Risultati";
var Review = "Recensione";
var Routing = "Instradamento";
var Satellite = "Satellite";
var Saturday = "Sabato";
var Save = "Salva";
var Scanning = "In fase di scansione";
var Schedule = "Pianifica";
var Search = "Ricerca";
var Secret = "Segreto";
var Select = "Seleziona";
var Sending = "Invio";
var September = "Settembre";
var Serverless = "Senza server";
var Service = "service";
var Settings = "Impostazioni";
var Size = "Dimensione";
var Sort = "Ordina";
var Source = "Origine";
var Start = "Avvia";
var State = "Stato";
var Status = "Condizione";
var Storage = "Archiviazione";
var Submit = "Inoltra";
var Subscription = "Sottoscrizione";
var Success = "Operazione riuscita";
var Summary = "Riepilogo";
var Sunday = "Domenica";
var Sydney = "Sydney";
var tag = "identificativo";
var tags = "tags";
var Tags = "Tag";
var Thursday = "Giovedì";
var Tokyo = "Tokyo";
var Topics = "Argomenti";
var Toronto = "Toronto";
var Total = "Totale";
var Trash = "Cestino";
var Trial = "Versione di prova";
var Tuesday = "Martedì";
var Unknown = "Sconosciuto";
var Unsupported = "Non supportato";
var Update = "Aggiornamento";
var Upgrade = "Aggiorna";
var Value = "Valore";
var Values = "Valori";
var Version = "Versione";
var View = "Visualizza";
var Warning = "Avvertenza";
var Wednesday = "Mercoledì";
var Workloads = "Carichi di lavoro";
var Yes = "Sì";
var Zone = "Zona";
var Zones = "Zone";
var it = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' esiste già. Immetti un altro nome.",
	"'Day of week' matches in addition to 'Day of month'": "'Giorno della settimana' si abbina in aggiunta a 'Giorno del mese'",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "'Giorno della settimana' si abbina in aggiunta a 'Giorno del mese'. L'espressione si attiva ogni giorno.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} elementi selezionati",
	"{{count}} resources": "{{count}} risorse",
	"{{count}} resources included": "{{count}} risorse incluse",
	"{{current}} of {{total}} pages": "{{current}} di {{total}} pagine",
	"{{datahookName}} response": "Risposta {{datahookName}}",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "Modelli {{label}}",
	"{{min}}–{{max}} items": "{{min}}–{{max}} elementi",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} di {{total}} elementi",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} moduli, {{resourcesCount}} risorse",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} richiede le seguenti opzioni per essere distribuito.",
	"{{price}} per {{unit}}": "{{price}} per {{unit}}",
	"{{price}} per month": "{{price}} per mese",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mese",
	"{{resourcesCount}} resources": "{{resourcesCount}} risorse",
	"{{rolesCount}} Role": "{{rolesCount}} ruolo",
	"{{rolesCount}} Roles": "{{rolesCount}} ruoli",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} argomento attivo per questa istanza.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} argomenti attivi per questa istanza.",
	"{{value}} percent status progress": "Avanzamento stato percentuale {{value}}",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (crea un nuovo cluster per provare questa versione beta)",
	"{{version}} (update to an earlier version first)": "{{version}} (aggiorna prima a una versione precedente)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Devi avere un'istanza Cloud Object Storage per creare un'ubicazione Satellite.</span> <a>Ulteriori informazioni.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / istanza",
	"1 item selected": "1 elemento selezionato",
	"1 of 1 page": "1 di 1 pagina",
	"1 role": "1 ruolo",
	"1–1 of 1 item": "1–1 di 1 elemento",
	"A collection of keys that belong to your service instance.": "Una raccolta di chiavi che appartengono all'istanza del servizio.",
	"A key can only have 5 aliases.": "Una chiave può avere solo 5 alias.",
	"A Key Protect key": "Una chiave Key Protect",
	"A location name is required. ": "È richiesto un nome ubicazione. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "Un servizio di gestione chiavi multi-tenant. Creare e gestire le chiavi crittografiche per crittografare i dati nelle applicazioni e controllare l'accesso ai dati.",
	"A name is required.": "Un nome è obbligatorio.",
	"A rotation policy of 12 months is recommended": "Si raccomanda una politica di rotazione di 12 mesi",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "È necessaria un'autorizzazione da servizio a servizio tra {{sourceServiceDisplayName}} e {{serviceDisplayName}} per associare la chiave di crittografia. Key Protect ne creerà una con il vostro consenso. Oppure è possibile crearne una manualmente.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "Un servizio di gestione chiavi single-tenant. Creare e gestire chiavi crittografiche con funzionalità di inserimento delle chiavi nel vault fornite da un HSM (Hardware Security Module) dedicato, controllato dal cliente. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "Una tag può includere solo caratteri alfanumerici, spazi, caratteri di sottolineatura, trattini, punti e un solo carattere due punti.",
	"A tag cannot end with a colon.": "Una tag non può terminare con un carattere due punti.",
	"A tag cannot include more than 128 characters.": "Una tag non può includere più di 128 caratteri.",
	"A tag cannot start with a colon.": "Una tag non può iniziare con un carattere due punti.",
	"A tag should not have spaces around a colon.": "Un tag non deve contenere spazi prima o dopo i due punti.",
	About: About,
	Access: Access,
	"Access management tags": "Tag di gestione accesso",
	"Access management tags (optional)": "Tag di gestione accessi (facoltativo)",
	"Access management tags help you apply flexible access policies on specific resources.": "Le tag di gestione dell'accesso consentono di applicare politiche di accesso flessibili a risorse specifiche.",
	Account: Account,
	"Account type": "Tipo di account",
	"Action required": "Azione richiesta",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Promozioni attive",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La raccolta di eventi di Activity tracker (tracker delle attività) è abilitata per questa risorsa ed inviata ai target come definito dalla configurazione del routing.",
	"Activity tracker events": "Eventi dell'Activity Tracker",
	"Activity tracking": "Traccia delle attività",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Aggiungi uno o più spazi dei nomi all'elenco del tuo spazio dei nomi specifico.",
	"Add a single project or multiple projects to your specific project's list.": "Aggiungi uno o più progetti all'elenco del tuo progetto specifico.",
	"Add Activity tracker event collection": "Aggiungere la raccolta di eventi di Activity Tracker",
	"Add activity tracking": "Aggiungi traccia delle attività",
	"Add event collection": "Aggiungere una raccolta di eventi",
	"Add hosts": "Aggiungi host",
	"Add hosts to meet the minimum service requirements.": "Aggiungere gli host per soddisfare i requisiti minimi del servizio.",
	"Add key alias (optional)": "Aggiungi alias chiave (facoltativo)",
	"Add key description (optional)": "Aggiungere la descrizione della chiave (opzionale)",
	"Add logging": "Aggiungi registrazione",
	"Add monitoring": "Aggiungi monitoraggio",
	"Add namespace": "Aggiungere spazio dei nomi",
	"Add New": "Aggiungi nuovo",
	"Add project": "Aggiungi progetto",
	"Add storage": "Aggiungi archiviazione",
	"Add tags": "Aggiungi tag",
	"Add to estimate": "Aggiungi a stima",
	"Add to existing": "Aggiungi a esistente",
	"Add to project": "Aggiungi a progetto",
	"Adding ...": "Aggiunta...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Intraprendere le azioni necessarie indicate di seguito per eseguire correttamente il provisioning del servizio. È possibile completare questi passi ora, o dopo la creazione del servizio.",
	"Address field": "Campo Indirizzo",
	Advanced: Advanced,
	"Advanced options": "Opzioni avanzate",
	"After connection": "Dopo la connessione",
	"After the service cluster is created, assign storage to the cluster.": "Dopo aver creato il cluster del servizio, assegnare spazio di archiviazione al cluster.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Dopo aver disconnesso Event Notifications, l'istanza {{serviceName}} viene rimossa dall'elenco dei servizi di origine nell'istanza Event Notifications.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Gli alias possono contenere solo caratteri alfanumerici e -_.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Gli alias devono essere composti da almeno 2 e al massimo 90 caratteri.",
	all: all,
	All: All,
	"All audit events (default target)": "Tutti gli eventi di audit (target predefinito)",
	"All audit events from your account will be sent to a new instance": "Tutti gli eventi di audit dell'account verranno inviati ad una nuova istanza",
	"All audit events from your account will be sent to an existing instance": "Tutti gli eventi di audit del vostro account saranno inviati a un'istanza esistente",
	"All namespaces": "Tutti gli spazi dei nomi",
	"All namespaces not supported": "Tutti gli spazi dei nomi non supportati",
	"All platform logs": "Tutti i registri della piattaforma",
	"All prerequisite services are installed on the location.": "Tutti i servizi prerequisiti sono installati nell'ubicazione.",
	"All projects": "Tutti i progetti",
	"All projects not supported": "Tutti i progetti non supportati",
	"All regions": "Tutte le regioni",
	"All resource groups": "Tutti i gruppi di risorse",
	"All secret groups": "Tutti i gruppi di segreti",
	"All types": "Tutti i tipi",
	"All zone names must be unique": "Tutti i nomi zona devono essere univoci",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Azioni consentite per il ruolo {{roleName}} ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "Hai già un account? <a>Accedi</a>",
	"An error occurred when fetching secrets. Try again later.": "Si è verificato un errore in fase di recupero dei segreti. Riprova più tardi.",
	"An instance of Event Notifications <a>Create new instance</a>": "Un'istanza di Event Notifications <a>Crea nuova istanza</a>",
	"An unexpected error occurred.": "Si è verificato un errore imprevisto.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analizzare e gestire i registri per una rapida risoluzione dei problemi e una prevenzione proattiva dei tempi di inattività. <a>Ulteriori informazioni</a>",
	Apply: Apply,
	"Apply a code": "Applica un codice",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "Si è sicuri di voler disconnettere l'istanza {{serviceName}} dall'istanza \"{{ENInstanceName}}\"?",
	"Are you sure you want to close the side panel?": "Si è sicuri di voler chiudere il pannello laterale?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "Si è sicuri di voler chiudere questo pannello? Le selezioni effettuate andranno perse.",
	"Are you sure?": "Confermare l'operazione?",
	Assign: Assign,
	"Associate key": "Associa chiave",
	"Attachment name": "Nome allegato",
	"Audit event collection is already enabled for this resource": "La raccolta di eventi di audit è già abilitata per questa risorsa",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "La raccolta di eventi di audit è consigliata per una risoluzione ottimale dei problemi e per ridurre i tempi di inattività",
	"Audit events (error)": "Eventi di audit (errore)",
	"Audit events from {{region}} will be sent to a new instance": "Gli eventi di audit da {{region}} saranno inviati ad una nuova istanza",
	"Audit events from {{region}} will be sent to an existing instance": "Gli eventi di audit da {{region}} saranno inviati ad un'istanza già esistente",
	"Audit events in {{region}}": "Eventi di audit in {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Gli eventi di audit verranno raccolti dai servizi IBM Cloud abilitati, in base all'ambito di routing definito.",
	"Audit events...": "Eventi di audit...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "È richiesta l'autenticazione o non disponi delle autorizzazioni corrette per eseguire questa azione.",
	"Authorization error": "Errore di autorizzazione",
	"Authorization met": "Autorizzazione soddisfatta",
	"Authorization needed": "Autorizzazione necessaria",
	"Authorize now": "Autorizza ora",
	"Authorizing...": "Autorizzazione...",
	Back: Back,
	"Base URI": "URI di base",
	"Base64 encoded key material": "Materiale della chiave codificate in Base64",
	Basic: Basic,
	"Before you begin": "Prima di iniziare",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Prima che il progetto possa convalidare o distribuire le configurazioni, il servizio Progetti deve essere autorizzato in questo account per comunicare con Schematics, Gestione catalogo, Secrets Manager e Resource Controller. Un utente con l'accesso richiesto a tali servizi può concedere automaticamente le autorizzazioni creando un progetto in questo account oppure può creare le autorizzazioni dei servizi manualmente. Questa autorizzazione è richiesta solo una volta.",
	"Billing information": "Informazioni di fatturazione",
	"Billing period": "Periodo di fatturazione",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Nome bucket",
	"By {{name}}": "Da {{name}}",
	"By clicking Save, you are creating the following access:": "Facendo clic su Salva, viene creato il seguente accesso:",
	"Can't retrieve details": "Impossibile richiamare i dettagli",
	Cancel: Cancel,
	"Cannot list integrations!": "Impossibile elencare le integrazioni.",
	"Cannot view keys in this instance": "Impossibile visualizzare le chiavi in questa istanza",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Si applicano addebiti. <a>Ulteriori informazioni</a>",
	"Choose a cluster version": "Scegliere una versione cluster",
	"Choose a key ring": "Selezionare un file di chiavi",
	"Choose a resource group": "Selezionare un gruppo di risorse",
	"Choose account...": "Scegli account...",
	"Choose an existing HPCS instance.": "Scegliere un'istanza HPCS esistente.",
	"Choose an existing Key Protect instance.": "Scegliere un'istanza Key Protect esistente.",
	"Choose an instance": "Scegliere un'istanza",
	"Choose an option": "Scegliere un'opzione",
	"Choose category...": "Scegli categoria...",
	"Choose location": "Scegli ubicazione",
	"Choose plan": "Scegli un piano",
	"Choose property...": "Scegli proprietà...",
	"Choose provider...": "Scegli provider...",
	"Choose secret...": "Scegli segreto...",
	"Choose service instance...": "Scegli istanza del servizio...",
	"Choose source name...": "Scegli nome origine...",
	"Choose source...": "Scegli origine...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Scegli quale istanza IBM Cloud Monitoring riceverà le metriche della piattaforma dalle istanze del servizio abilitate su IBM Cloud.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Scegli quale istanza IBM Log Analysis riceverà i log della piattaforma dalle istanze del servizio abilitate su IBM Cloud.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Cancella tutto",
	"Clear all selected items": "Cancella tutti gli elementi selezionati",
	"Clear filters": "Cancella filtri",
	"Clear selected": "Cancella selezionati",
	"Clear selected item": "Cancella voce selezionata",
	"Clear selection": "Annulla selezione",
	CLI: CLI,
	Close: Close,
	"Close menu": "Chiudi menu",
	"Close page navigation menu": "Chiudi menu di navigazione delle pagine",
	"Close Panel": "Chiudi pannello",
	"Close Push Panel": "Chiudi Pannello Push",
	"Closing side panel": "Chiusura del pannello laterale",
	"Cloud Logs": "Log cloud",
	"Cloud Logs instance": "Istanza dei Registri Cloud",
	"Cloud Logs instance name": "Nome istanza dei Registri Cloud",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Istanza Cloud Object Storage",
	"Cluster \"{{name}}\" is being deleted.": "Il cluster \"{{name}}\" è stato eliminato.",
	"Cluster management": "Gestione del cluster",
	"Cluster version": "Versione cluster",
	"Cluster version cannot be updated.": "La versione del cluster non può essere aggiornata.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Esempio di codice",
	"Collapse all rows": "Comprimi tutte le righe",
	"Collapse group": "Comprimi gruppo",
	"Collapse row": "Comprimi riga",
	"Collapse summary": "Comprimi riepilogo",
	"Compact (24px)": "Compatta (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Dettagli della configurazione",
	"Configuration name": "Nome configurazione",
	Configure: Configure,
	"Configure activity tracking": "Configura traccia delle attività",
	"Configure encryption": "Configura crittografia",
	"Configure logging": "Configura registrazione",
	"Configure monitoring": "Configura monitoraggio",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Connetti a Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Collegare l'istanza {{serviceName}} ad un'istanza Event Notifications esistente.",
	Connected: Connected,
	"Connected instance": "Istanza connessa",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "L'istanza di Event Notifications connessa non esiste. Rivolgiti all'amministratore.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Contattare l'amministratore dell'account per accedere a un piano per eseguire il provisioning di Key Protect.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Contattare l'amministratore dell'account per accedere a un gruppo di risorse per eseguire il provisioning di Key Protect.",
	"Contact your administrator for access.": "Contattare l'amministratore per l'accesso.",
	"Contact your administrator for additional assistance.": "Contatta il tuo amministratore per ulteriore assistenza.",
	"Container registry": "Container Registry",
	Containers: Containers,
	"Copied to clipboard": "Copiato negli appunti",
	"Copy to clipboard": "Copia negli appunti",
	"Cost details": "Dettagli di costo",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "Impossibile caricare informazioni sulle tariffe. Aggiornare la pagina o riprovare successivamente.",
	Country: Country,
	Create: Create,
	"Create a key": "Crea una chiave",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Creare un obiettivo di routing dei registri per supportare la gestione e l'analisi dei registri per una rapida risoluzione dei problemi e una prevenzione proattiva dei tempi di inattività. <a>Ulteriori informazioni</a>",
	"Create a new instance to get started.": "Creare una nuova istanza per iniziare.",
	"Create a project": "Crea un progetto",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Crea un'ubicazione Satellite per portare IBM Cloud ovunque. Per ulteriori informazioni, <a>vedi la documentazione.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Creare una destinazione e un percorso di routing degli eventi di Activity Tracker per supportare il monitoraggio e l'audit delle attività di IBM Cloud per una maggiore sicurezza e conformità. <a>Ulteriori informazioni</a>",
	"Create an encryption key or import your own key.": "Creare una chiave di crittografia o importare la propria chiave.",
	"Create cluster": "Crea cluster",
	"Create failed": "Creazione non riuscita",
	"Create instance": "Crea istanza",
	"Create location": "Crea ubicazione",
	"Create new": "Crea nuovo",
	"Create new instance": "Crea nuova istanza",
	"Create new key": "Crea nuova chiave",
	"Create new secret": "Crea nuovo segreto",
	"Create reference": "Crea riferimento",
	"Create resource": "Crea risorsa",
	"Create Satellite location": "Crea ubicazione Satellite",
	"Create secret": "Crea segreto",
	"Create services": "Crea i servizi",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Creare argomenti, destinazioni e sottoscrizioni in Event Notifications per essere notificati degli eventi generati dal vostro {{serviceName}}",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Creazione in corso ...",
	"Creating...": "Creazione in corso...",
	Critical: Critical,
	"CRON expression": "Espressione CRON",
	Current: Current,
	Custom: Custom,
	"Custom access": "Accesso personalizzato",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Blocco argomento del Datahook",
	"Datahook Params": "Parametri del Datahook",
	"Datahook response": "Risposta del Datahook",
	"Day of month": "Giorno del mese",
	"Day of Month (UTC)": "Giorno del mese (UTC)",
	"Day of week": "Il giorno della settimana",
	"Day of week (UTC)": "Giorno della settimana (UTC)",
	December: December,
	"Dedicated hosts": "Host dedicati",
	"Default target": "Destinazione predefinita",
	"Default title": "Titolo predefinito",
	"Define project details": "Definisci i dettagli del progetto",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Definire gli intervalli ricorrenti degli eventi generati da questo evento. Selezionare un pattern predefinito e personalizzarlo in base alle proprie esigenze. Le pianificazioni sono specificate secondo il fuso orario UTC (Coordinated Universal Time).",
	"Define the scope of audit events collected": "Definire l'ambito degli eventi di audit raccolti",
	Delete: Delete,
	"Delete cluster": "Elimina cluster",
	"Delete failed": "Eliminazione non riuscita",
	"Delete retry wait": "Attesa per il tentativo di cancellazione",
	"Delete the persistent storage used by this cluster": "Elimina l'archiviazione persistente utilizzata da questo cluster",
	Deleting: Deleting,
	"Deleting...": "Eliminazione in corso...",
	"Deploy failed": "Distribuzione non riuscita",
	"Deploy retry wait": "Attesa per il tentativo di distribuzione",
	Deploying: Deploying,
	"Deployment ready": "Distribuzione pronta",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Versione obsoleta; il supporto terminerà in data {{when}}. Aggiorna la versione per continuare a ricevere supporto.",
	"Description (optional)": "Descrizione (facoltativa)",
	"Description of the source": "Descrizione dell'origine",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Disconnetti Event Notifications",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "Le etichette del dominio secondario DNS non devono contenere più di {{maxLength}} caratteri.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Modifica terminata",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "Durante l'aggiornamento, il master, i nodi di lavoro, le applicazioni e le risorse del tuo cluster continuano a essere eseguiti. Al termine dell'aggiornamento, puoi aggiornare le versioni dei nodi di lavoro. Per istruzioni e ulteriori informazioni sulle differenze tra le versioni, <a>consulta la documentazione</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Integrazione delle modifiche dell'activity tracker",
	"Edit Array": "Modifica array",
	"Edit columns": "Modifica colonne",
	"Edit configuration": "Modifica configurazione",
	"Edit details": "Modifica dettagli",
	"Edit JSON": "Modifica JSON",
	"Edit logging integration": "Integrazione della registrazione delle modifiche",
	"Edit secure value": "Modifica valore sicuro",
	"Edit tags": "Modifica tag",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Abilitare le notifiche del ciclo di vita per l'istanza {{serviceName}} collegando un'istanza di servizio Event Notifications.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Abilita la supervisione, la conformità e controlla le operazioni e i rischi per gestire il tuo account IBM Cloud.",
	Encryption: Encryption,
	"Encryption key associated": "Chiave di crittografia associata",
	"Encryption options menu": "Menu delle opzioni di crittografia",
	End: End,
	"End date": "Data di fine",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Migliora la tua esperienza con Schematics mediante le integrazioni. Inizia ad aggiungere integrazioni oggi stesso selezionando una delle seguenti opzioni.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Immettere un nome per la configurazione dell'architettura distribuibile.  Ad esempio: production-vpc",
	"Enter a password": "Immetti una password",
	"Enter a valid CRN": "Inserire un CRN valido",
	"Enter array values. Quotations are added to values after you save.": "Immettere i valori di array. Le virgolette vengono aggiunte ai valori dopo il salvataggio.",
	"Enter name and description": "Immettere nome e descrizione",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Immetti i nomi per le zone host. Per l'alta disponibilità, assegna i tuoi host in queste tre zone in base alle zone del tuo provider di infrastruttura. <a>Perché ho bisogno delle zone?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Immetti gli spazi dei nomi separati da una virgola. Dopo aver fatto clic su Aggiungi, i nuovi spazi dei nomi vengono inclusi nell'elenco e selezionati automaticamente.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Immetti i progetti separati da una virgola. Dopo aver fatto clic su Aggiungi, i nuovi progetti vengono inclusi nell'elenco e selezionati automaticamente.",
	"Enter source name": "Immettere il nome dell'origine",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Immetti il nome esatto di un bucket esistente nella tua istanza Cloud Object Storage. Se non viene fornito un nome, viene creato un nuovo bucket per te.",
	Enterprise: Enterprise,
	"Entire secret": "Intero segreto",
	"Environment (optional)": "Ambiente (facoltativo)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Gli ambienti possono contenere proprietà condivise tra configurazioni correlate. All'interno della configurazione, è possibile sovrascrivere qualsiasi valore fornito dall'ambiente. <a>Ulteriori informazioni</a>",
	"Error": "Errore",
	"Error checking existing services status": "Errore durante il controllo dello stato dei servizi esistenti",
	"Error checking host status": "Errore durante il controllo dello stato dell'host",
	"Error checking storage status": "Errore durante il controllo dello stato dello spazio di archiviazione",
	"Error fetching tags": "Errore durante il recupero delle tag",
	"Error icon": "Icona di errore",
	"Error loading accounts": "Errore durante il caricamento degli account",
	"Error loading categories": "Errore durante il caricamento delle categorie",
	"Error loading groups": "Errore durante il caricamento dei gruppi",
	"Error loading instances": "Errore durante il caricamento delle istanze",
	"Error loading keys": "Errore durante il caricamento delle chiavi",
	"Error loading pricing": "Errore di caricamento delle tariffe",
	"Error loading properties": "Errore durante il caricamento delle proprietà",
	"Error loading providers": "Errore durante il caricamento dei provider",
	"Error loading regions": "Errore durante il caricamento delle regioni",
	"Error loading resource groups": "Errore nel caricamento dei gruppi di risorse",
	"Error loading S2S auth": "Errore durante il caricamento dell'autorizzazione S2S",
	"Error loading secrets": "Errore durante il caricamento dei segreti",
	"Error loading source names": "Errore durante il caricamento dei nomi origine",
	"Error loading sources": "Errore durante il caricamento delle origini",
	"Error loading types": "Errore durante il caricamento dei tipi",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Errore durante la convalida di questo codice. Assicurati di non includere virgolette nel codice promozionale.",
	Establish: Establish,
	"Estimate costs": "Stima i costi",
	"Estimated cost per instance": "Costo stimato per istanza",
	"Estimated starting cost": "Costo iniziale stimato",
	"Estimated total ({{count}} instances)": "Totale stimato ({{count}} istanze)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Istanza di Event Notifications",
	"Event Notifications service instance": "Istanza del servizio di Event Notifications",
	"Event Source Manager": "Gestore origine eventi",
	"Every 2 hours": "Ogni 2 ore",
	"Every 2 minutes": "Ogni 2 minuti",
	"Every 3 hours": "Ogni 3 ore",
	"Every 4 hours": "Ogni 4 ore",
	"Every 5 minutes": "Ogni 5 minuti",
	"Every 6 hours": "Ogni 6 ore",
	"Every 10 minutes": "Ogni 10 minuti",
	"Every 15 minutes": "Ogni 15 minuti",
	"Every day": "Ogni giorno",
	"Every fifth day": "Ogni cinque giorni",
	"Every fourth day": "Ogni quattro giorni",
	"Every fourth month": "Ogni quattro mesi",
	"Every hour": "Ogni ora",
	"Every minute": "Ogni minuto",
	"Every month": "Ogni mese",
	"Every second day": "Ogni due giorni",
	"Every second month": "Ogni due mesi",
	"Every sixth month": "Ogni sei mesi",
	"Every third day": "Ogni tre giorni",
	"Every third month": "Ogni tre mesi",
	"Examples: access:dev, proj:version-1": "Esempi: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Esempi: env:dev, version-1",
	"Existing instance": "Istanza esistente",
	"Exiting encryption selection": "Uscita dalla selezione della crittografia",
	"Expand all rows": "Espandi tutte le righe",
	"Expand group": "Espandi gruppo",
	"Expand row": "Espandi riga",
	"Expand summary": "Espandi riepilogo",
	Expired: Expired,
	"Expired (beta)": "Scaduto (beta)",
	"Expires {{when}}": "Scade {{when}}",
	"Expires after beta": "Scade dopo la versione beta",
	"Extra large (64px)": "Extra grande (64px)",
	"Extra small (24px)": "Extra piccolo (24px)",
	Failed: Failed,
	"Failed to check permission": "Non è stato possibile verificare l'autorizzazione",
	"Failed to create configuration": "Non è stato possibile creare la configurazione",
	"Failed to create key": "Non è stato possibile creare la chiave",
	"Failed to create policy": "Impossibile creare la politica",
	"Failed to create project": "Non è stato possibile creare il progetto",
	"Failed to fetch": "Impossibile eseguire il recupero",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "Impossibile recuperare le istanze IBM Cloud Activity Tracker.",
	"Failed to fetch IBM Cloud Monitoring instances.": "Impossibile recuperare le istanze IBM Cloud Monitoring.",
	"Failed to fetch IBM Log Analysis instances.": "Impossibile recuperare le istanze IBM Log Analysis.",
	"failure state": "stato di esito negativo",
	February: February,
	"Fetch data": "Recupero dei dati",
	Filter: Filter,
	"Filter instance by region": "Filtra l'istanza per regione",
	"Filter...": "Filtro...",
	Filters: Filters,
	"Filters:": "Filtri:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Finalizzazione del cluster...",
	"Finalizing workers...": "Finalizzazione dei nodi di lavoro in corso...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "Ottieni visibilità operativa sulle tue risorse cloud con IBM Cloud Activity Tracker.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "Ottieni visibilità operativa sulle tue risorse cloud con IBM Cloud Monitoring.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "Ottieni visibilità operativa sulle tue risorse cloud con IBM Log Analysis.",
	"Get started": "Introduzione",
	"Get started with Security and Compliance Center": "Introduzione a Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Assegnate alla vostra chiave un alias per poterla recuperare facilmente in seguito.",
	"Helm catalog": "Catalogo Helm",
	Help: Help,
	"Hide password": "Nascondi password",
	"Host usage\n(used / total)": "Utilizzo host (utilizzato / totale)",
	"Hosts needed": "Host necessari",
	"Hosts requirements met": "Requisiti degli host soddisfatti",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Ora (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "Accetto di usare il mio token per creare una politica da servizio a servizio tra il servizio di origine {{sourceServiceDisplayName}} e il servizio di destinazione {{serviceDisplayName}} per mio conto.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "Confermo di voler interrompere la ricezione dei log della piattaforma da {{instance}}",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "Confermo di voler interrompere la ricezione delle metriche della piattaforma da {{instance}}",
	"IaaS ready": "Pronto per IaaS",
	IAM: IAM,
	"IAM credentials": "Credenziali IAM",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "Se non è stato assegnato alcun portachiavi, il tasto verrà aggiunto al portachiavi predefinito.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "Se selezionato, l'array verrà salvato come stringa \"__NOT_SET__\".",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "Se il valore iniziale non era un array di stringhe valido, di seguito verrà visualizzato un array a elemento singolo o vuoto.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "Se le tue tag utente sono correlate alla fatturazione, valuta la possibilità di scrivere le tag come coppie chiave:valore, come ad esempio",
	Images: Images,
	"Import your own key": "Importa le tue chiavi",
	"In progress": "In corso",
	"in progress state": "stato in corso",
	Inactive: Inactive,
	"inactive state": "stato inattivo",
	Incomplete: Incomplete,
	"incomplete state": "stato incompleto",
	Information: Information,
	"information state": "stato informazioni",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Zone infrastrutturali",
	Instance: Instance,
	"Instance ID": "ID istanza",
	"Instance location": "Ubicazione istanza",
	"Instance name": "Nome istanza",
	"Instance(s) in {{region}}": "Istanza(e) in {{region}}",
	"Instance(s) in region": "Istanza(e) nella regione",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Errore del server interno. Attendere un minuto e ripetere l'azione. Se il problema persiste, aprire un ticket di supporto.",
	"Interpolated URI": "URI interpolato",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Oggetto del datahook non valido, vengono utilizzate le ultime opzioni valide",
	"Invalid label name.": "Nome etichetta non valido.",
	"Invalid label prefix or name.": "Prefisso o nome etichetta non valido.",
	"Invalid label value.": "Valore etichetta non valido.",
	"Items per page:": "Elementi per pagina:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Alias chiave",
	"Key CRN": "Chiave CRN",
	"Key description": "Descrizione chiave",
	"Key description must be at least 2 characters and no more than 240 characters.": "La descrizione della chiave deve contenere un minimo di 2 e un massimo di 240 caratteri.",
	"Key ID": "ID chiave",
	"Key management": "Gestione chiavi",
	"Key management service": "Key Management Service",
	"Key material": "Materiale della chiave",
	"Key material is required to import a key": "Per importare una chiave è necessario il materiale della chiave",
	"Key material length must be 128, 192, or 256 bits": "La lunghezza del materiale della chiave deve essere di 128, 192 o 256 bit",
	"Key material must be base64": "Il materiale della chiave deve essere base64",
	"Key name": "Nome chiave",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Nome Istanza Key Protect",
	"Key ring": "Key ring",
	"Key value": "Valore della chiave",
	"Label must be of the form 'key:value'.": "L'etichetta deve essere del formato \"key:value\".",
	"Label name must be no more than {{maxLength}} characters.": "Il nome dell'etichetta non deve contenere più di {{maxLength}} caratteri.",
	"Label prefix must be a valid DNS subdomain.": "Il prefisso dell'etichetta deve essere un sottodominio DNS valido.",
	"Label prefix must be no more than {{maxLength}} characters.": "Il prefisso dell'etichetta non deve contenere più di {{maxLength}} caratteri.",
	"Label value must be no more than {{maxLength}} characters.": "Il valore dell'etichetta non deve contenere più di {{maxLength}} caratteri.",
	"Large (48px)": "Grande (48px)",
	"Last modified": "Ultima modifica",
	"Last scanned": "Ultima scansione",
	"Last updated": "Ultimo aggiornamento",
	Launch: Launch,
	"Launch activiting tracking": "Avvia tracciamento di attivazione",
	"Launch in new window": "Avvia in una nuova finestra",
	"Launch logging": "Avvia registrazione",
	"Launch monitoring": "Avvia monitoraggio",
	"Learn more": "Ulteriori informazioni",
	"learn more.": "Ulteriori informazioni.",
	"Learn more.": "Ulteriori informazioni.",
	"List of actions": "Elenco delle azioni",
	"list of code sample types": "elenco di tipi di esempi di codici",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Indicatore di caricamento",
	"Loading...": "Caricamento in corso...",
	"Locate by CRN within your account": "Individuare il CRN all'interno del proprio account",
	Location: Location,
	"Location summary": "Riepilogo ubicazione",
	"Location:": "Ubicazione:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "La raccolta dei registri è già abilitata per questa risorsa",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La raccolta dei registri è abilitata per questa risorsa e inviata ai target definiti dalla configurazione del routing.",
	Logging: Logging,
	"Logging (error)": "Registrazione (errore)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "La registrazione è consigliata per una risoluzione ottimale dei problemi e per ridurre i tempi di inattività",
	"Logging...": "Registrazione...",
	London: London,
	"Looking for valid service to service authorization policy...": "Cercare una politica di autorizzazione valida da servizio a servizio...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Sembra che manchino le autorizzazioni necessarie per creare la politica. Contattare l'amministratore dell'account",
	"Looks like you don't have access to view account information.": "Sembra che tu non disponga dell'accesso per visualizzare le informazioni sull'account.",
	"Looks like you don't have access to view the billing period": "Sembra che tu non disponga dell'accesso per visualizzare il periodo di fatturazione",
	"Looks like you don't have any scans": "Sembra che non ci sia alcuna scansione",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Sembra che non si disponga dell'accesso necessario per visualizzare queste informazioni. Contattare l'amministratore dell'account per verificare le autorizzazioni.",
	"Looks like you don't have the correct access": "Sembra che tu non abbia l'accesso corretto",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Non si dispone dell'accesso corretto. Per creare un'autorizzazione tra i servizi, devi disporre dell'accesso al servizio di destinazione.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Assicurarsi di aver configurato argomenti, sottoscrizioni e destinazioni in Event Notifications.",
	"Manage encryption by enabling a key management service (KMS).": "Gestire la crittografia abilitando un servizio di gestione delle chiavi (KMS).",
	"Manage routing": "Gestire il routing",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Gestisci il ciclo di vita delle tue chiavi di crittografia utilizzate per le tue risorse, servizi e applicazioni IBM Cloud.",
	"Managed from": "Gestito da",
	March: March,
	May: May,
	"Media gallery video": "Video della galleria multimediale",
	"Medium (40px)": "Medio (40px)",
	"Metadata location": "Ubicazione dei metadati",
	Metro: Metro,
	"Minimum host requirements are met.": "I requisiti minimi degli host sono soddisfatti.",
	Minute: Minute,
	"Minute (UTC)": "Minuto (UTC)",
	"Missing prerequisite services": "Servizi prerequisiti mancanti",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Modificare gli argomenti passati nel proprio datahook qui.",
	"Mon-Fri": "Lun-Ven",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Monitorare la conformità di tutti gli ambienti impostando le scansioni.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Monitorate e verificare le attività di IBM Cloud per una maggiore sicurezza e conformità. <a>Ulteriori informazioni</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Mese (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "Nome già in uso. Specifica un nome univoco.",
	"Name must be between 2 and 90 characters": "Il nome deve essere compreso tra 2 e 90 caratteri",
	"Name this project": "Denominare questo progetto",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "Nuova istanza",
	Next: Next,
	"Next page": "Pagina successiva",
	"Next: Customize": "Avanti: Personalizzare",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "Nessuna regione del catalogo disponibile",
	"No Cloud Object Storage instance is available.": "Non è disponibile alcuna istanza Cloud Object Storage.",
	"No code preview has been configured for terraform. Please visit our docs to ": "Non è stata configurata alcuna anteprima del codice per terraform. Si prega di visitare i nostri docs a ",
	"No configurations available": "Nessuna configurazione disponibile",
	"No events can be scheduled with your selected CRON expression.": "Non è possibile pianificare alcun evento con l'espressione CRON selezionata.",
	"No Hyper Protect Crypto Services instances found": "Nessuna istanza Hyper Protect Crypto Services trovata",
	"No instances found": "Non è stata trovata alcuna istanza",
	"No item matches the filters. Clear the filters and try again.": "Nessun elemento corrispondente ai filtri. Cancella i filtri e riprova.",
	"No items available to display. Select an instance and bucket to view objects.": "Nessun elemento disponibile da visualizzare. Selezionare un'istanza e un bucket per visualizzare gli oggetti.",
	"No items match the current filter.": "Nessun elemento corrisponde al filtro corrente.",
	"No keys available": "Nessuna chiave disponibile",
	"No matches found. To create new tags, contact your tag administrator.": "Non è stata trovata alcuna corrispondenza. Per creare nuove tag, contatta il tuo amministratore di tag.",
	"No matching options": "Nessuna opzione corrispondente",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "Non sono disponibili ID regione corrispondenti su questo account. Se si pensa che si tratti di un errore, aggiornare la pagina o contattare l'amministratore.",
	"No plans found": "Nessun piano trovato",
	"No regions available": "Nessuna regione disponibile",
	"No resource groups available": "Nessun gruppo di risorse disponibile",
	"No secret available": "Nessun segreto disponibile",
	"No secret group available": "Nessun gruppo di segreti disponibile",
	"No service instance available": "Non è disponibile alcuna istanza del servizio",
	"No valid version update options are available.": "Non è disponibile nessuna opzione di aggiornamento versione valida.",
	"Non-compliant": "Non conforme",
	None: None,
	"None available": "Nessuno disponibile",
	Normal: Normal,
	"Normal (48px)": "Normale (48px)",
	"Not authorized": "Non autorizzato",
	"Not ready": "Non pronto",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Oggetto",
	"Object storage": "Archiviazione oggetti",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Object Storage viene utilizzato per archiviare i dati sulla tua ubicazione e i tuoi backup per i cluster della tua ubicazione. <a>Ulteriori informazioni.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Una volta al giorno",
	"Once a month": "Una volta al mese",
	"Once a week": "Una volta a settimana",
	"Once a year": "Una volta all'anno",
	Open: Open,
	"Open dashboard": "Apri dashboard",
	"Open Dashboard": "Apri dashboard",
	"Open menu": "Apri menu",
	"Open page navigation menu": "Apri menu di navigazione delle pagine",
	"Open reference picker": "Aprire il selettore di riferimenti",
	"Open tab list": "Apri elenco schede",
	Osaka: Osaka,
	"Overflow menu": "Menu di overflow",
	"Overflow Menu": "Menu di overflow",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "pagina {{pageNumber}}",
	"Page Navigation": "Navigazione della pagina",
	"Page navigation menu": "Menu di navigazione delle pagine",
	"Page number": "Numero di pagina",
	Pattern: Pattern,
	"Pay-As-You-Go": "Pagamento a consumo",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Accesso alla piattaforma",
	"Platform logs from {{region}} will be sent to a new instance": "I registri della piattaforma da {{region}} saranno inviati ad una nuova istanza",
	"Platform logs from {{region}} will be sent to an existing instance": "I registri della piattaforma da {{region}} saranno inviati ad un'istanza esistente",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "I registri della piattaforma da {{region}} saranno inviati all'istanza di destinazione. <a>Ulteriori informazioni</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "I registri della piattaforma verranno raccolti dai servizi IBM Cloud abilitati, in base all'ambito di routing definito.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "<a>Registrati</a> per creare o <a>accedi</a> prima di applicare il codice promozionale.",
	"Prefix filter": "Filtro prefisso",
	Premium: Premium,
	"Preparing master, workers...": "Preparazione di master, nodi di lavoro in corso...",
	"Preparing master...": "Preparazione del master in corso...",
	"Prerequisite services installed": "Servizi prerequisiti installati",
	Previous: Previous,
	"Previous page": "Pagina precedente",
	"Pricing Plans": "Piani tariffari",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Fornire una descrizione più dettagliata della chiave. Per proteggere la propria privacy, non utilizzare i dati personali, come il proprio nome o la propria ubicazione, come descrizione. Non è possibile modificarla dopo la creazione della chiave.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Fornisce la visibilità sulle prestazioni e sull'integrità delle applicazioni delle risorse basate su IBM Cloud.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "Pronto ad applicare?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Aggiorna le istanze Cloud Object Storage",
	"Refresh data": "Aggiorna dati",
	"Refresh secrets": "Aggiorna segreti",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Rimuovi ordinamento",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "Il rendering degli hook di modifica non è supportato per impedire modifiche di risorse non previste.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Richiesta di creazione in corso...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Reimposta filtri",
	"Reset to default": "Reimposta su valore predefinito",
	"Reset zoom": "Reimposta zoom",
	"Resource Configuration": "Configurazione risorsa",
	"Resource group": "Gruppo di risorse",
	"Resource group:": "Gruppo di risorse:",
	"Resource list": "Elenco risorse",
	"Resource List": "Elenco risorse",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Risorse non incluse nel costo",
	"Restricted access": "Accesso limitato",
	Results: Results,
	"Retrying delete": "Nuovo tentativo di eliminazione in corso",
	"Retrying deploy": "Nuovo tentativo di distribuzione in corso",
	"Revert {{resetCount}} to default": "Ripristina {{resetCount}} al valore predefinito",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Riesamina le assegnazioni dell'accesso a {{resourceDisplayName}}",
	"Review settings in Event Notifications": "Esaminare le impostazioni in Event Notifications",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Riesamina le seguenti politiche del gruppo di accesso per assicurarti di assegnare il livello di accesso corretto.",
	"Rotation interval": "Intervallo di rotazione",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "Le politiche di rotazione determinano l'intervallo tra le rotazioni delle chiavi automatiche. Un intervallo di un mese, ad esempio, indica che una chiave verrà ruotata ogni 30 giorni. Se la politica è già abilitata, significa che esiste una politica dell'istanza per questa istanza e, se non vengono eseguite altre azioni, l'intervallo di rotazione mostrato verrà applicato alla chiave. Se è disabilitata, abilitarla per impostare una politica per questa chiave.",
	"Rotation policy": "Politica di rotazione",
	"Rotation policy disabled": "Politica di rotazione disattivata",
	"Route name": "Nome instradamento",
	Routing: Routing,
	"Routing scope": "Ambito di routing",
	"Row height": "Altezza riga",
	"Sample not yet available": "Esempio non ancora disponibile",
	"Sao Paulo": "San Paolo",
	"Sat-Sun": "Sab-Dom",
	Satellite: Satellite,
	"Satellite container": "Container Satellite",
	"Satellite location": "Ubicazione Satellite",
	"Satellite location base cost": "Costo base ubicazione Satellite",
	"Satellite location base functionality": "Funzionalità di base dell'ubicazione Satellite",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Salvataggio in corso...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Gli spazi di lavoro Schematics e altri dati del progetto vengono memorizzati nella regione e nel gruppo di risorse selezionati. <a>Ulteriori informazioni.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Gli spazi di lavoro Schematics vengono forniti in questa regione. Il progetto può comunque distribuire le risorse in qualsiasi regione.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Gli spazi di lavoro Schematics vengono forniti in questo gruppo di risorse. Il progetto può comunque distribuire le risorse a qualsiasi gruppo di risorse.",
	Search: Search,
	"Search in this instance": "Ricerca in questa istanza",
	Secret: Secret,
	"Secret configured": "Segreto configurato",
	"Secret group": "Gruppo di segreti",
	"Secret type": "Tipo di segreto",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Valore sicuro",
	"See details": "Visualizza dettagli",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Selezionare un'ubicazione per visualizzare quali passi devono essere eseguiti successivamente.",
	"Select a project": "Seleziona un progetto",
	"Select a reference": "Selezionare un riferimento",
	"Select a region": "Seleziona una regione",
	"Select a resource group": "Selezionare un gruppo di risorse",
	"Select a role to determine the level of access for the source service.": "Seleziona un ruolo per determinare il livello di accesso per il servizio di origine.",
	"Select a secret": "Seleziona un segreto",
	"Select a secret group": "Seleziona un gruppo di segreti",
	"Select a service instance": "Seleziona un'istanza del servizio",
	"Select all {{totalRowCount}} items": "Seleziona tutti e {{totalRowCount}} elementi",
	"Select all rows on page": "Seleziona tutte le righe nella pagina",
	"Select an environment": "Seleziona un ambiente",
	"Select an existing configuration": "Selezionare una configurazione esistente",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "Seleziona un'istanza IBM Cloud Monitoring per ricevere le metriche della piattaforma",
	"Select an IBM Log Analysis instance to receive platform logs": "Seleziona un'istanza IBM Log Analysis per ricevere i log della piattaforma",
	"Select an instance": "Seleziona un'istanza",
	"Select an instance to show keys": "Selezionare un'istanza per visualizzare le chiavi",
	"Select an option...": "Seleziona un'opzione ...",
	"Select existing key": "Seleziona chiave esistente",
	"Select from Secrets Manager": "Seleziona da Gestore segreti",
	"Select KMS instance": "Selezionare l'istanza KMS",
	"Select namespaces": "Seleziona spazi dei nomi",
	"Select one or more namespaces": "Seleziona uno o più spazi dei nomi",
	"Select one or more projects": "Seleziona uno o più progetti",
	"Select prerequisites": "Selezionare i prerequisiti",
	"Select projects": "Seleziona progetti",
	"Select region and resource group": "Seleziona regione e gruppo di risorse",
	"Select row": "Seleziona riga",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Selezionare la <a>regione IBM Cloud</a> più vicina a dove risiede la tua infrastruttura per garantire una bassa latenza di rete.",
	"Select the following tile to deploy it.": "Selezionate il seguente riquadro per distribuirlo.",
	"Send all audit events from enabled resources in {{region}}.": "Invia tutti gli eventi di audit dalle risorse abilitate in {{region}}.",
	"Send all available audit events in this account.": "Invia tutti gli eventi di audit disponibili in questo account.",
	"Send events to": "Inviare gli eventi a",
	"Send logs to": "Inviare le registrazioni a",
	"Send test notification": "Invia notifica di prova",
	Sending: Sending,
	"Sent!": "Inviato.",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Progetti serverless",
	Service: Service,
	"Service access": "Accesso al servizio",
	"Service authorization": "Autorizzazione del servizio",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "L'autorizzazione del servizio è necessaria per consentire a Activity Tracker Event Routing di comunicare con Cloud Logs. Fare clic su <span>Autorizza ora</span> per creare una politica con un raggio d'azione di tutte le risorse Cloud Logs di questo account.",
	"Service authorization required": "Autorizzazione di servizio richiesta",
	"Service instance": "Istanza del servizio",
	"Service name": "Nome servizio",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "L'autorizzazione service-to-service deve essere fornita per la propria istanza. <a>Ulteriori informazioni</a>",
	"Service to service authorization policy found": "Individuata una politica di autorizzazione da servizio a servizio",
	"Service to service authorization policy needed": "Necessaria una politica di autorizzazione da servizio a servizio",
	"Service type": "Tipo di servizio",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "Non è stato possibile verificare l'autorizzazione service-to-service. Aggiungere manualmente e controllare i ruoli necessari.",
	"Service-to-service authorization requirements are met.": "I requisiti di autorizzazione service-to-service sono soddisfatti.",
	"Set an interval (in months)": "Imposta un intervallo (in mesi)",
	"Set key rotation policy": "Imposta politica di rotazione chiavi",
	"Set up auth": "Configura autenticazione",
	Settings: Settings,
	"Short (32px)": "Bassa (32px)",
	"Show all filters": "Mostra tutti i filtri",
	"Show code sample": "Mostra esempio di codice",
	"Show environments information": "Mostra informazioni sugli ambienti",
	"Show error information": "Mostra informazioni sugli errori",
	"Show information": "Mostra informazioni",
	"Show less": "Mostra di meno",
	"Show more": "Mostra di più",
	"Show more details": "Mostra ulteriori dettagli",
	"Show password": "Mostra password",
	"Show tooltip": "Mostra descrizione degli strumenti",
	"Showing {{count}} item": "Visualizzazione di {{count}} elemento",
	"Showing {{count}} items": "Visualizzazione di {{count}} elementi",
	Size: Size,
	"Small (32px)": "Piccolo (32px)",
	"Some events from {{serviceName}}:": "Alcuni eventi di {{serviceName}}:",
	"Something went wrong": "Si è verificato un problema",
	"Something went wrong.": "Si è verificato un problema.",
	"Something went wrong. Try reloading the page to see this information": "Si è verificato un problema. Prova a ricaricare la pagina per visualizzare queste informazioni",
	Sort: Sort,
	"Sort ascending": "Ordinamento crescente",
	"Sort descending": "Ordinamento decrescente",
	Source: Source,
	"Source Details": "Dettagli origine",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "L'origine per il servizio non è presente nell'istanza Event Notifications. Rivolgiti all'amministratore.",
	"Source service": "Servizio di origine",
	"Specific namespaces not supported": "Specifici spazi dei nomi non supportati",
	"Specific projects not supported": "Specifici progetti non supportati",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Inizia creando un cluster perfetto per eseguire i tuoi carichi di lavoro.",
	"Start date": "Data di inizio",
	"Starting at": "A partire da",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "I costi iniziali si basano su questa configurazione di risorse. È possibile modificare le configurazioni dopo aver aggiunto il prodotto a un progetto, il che potrebbe avere un impatto sui costi.",
	State: State,
	Status: Status,
	"status icon": "icona dello stato",
	"Stay in pattern": "Rimani nel pattern",
	"Steps complete": "Passi completati",
	Storage: Storage,
	"Storage bucket (optional)": "Bucket di storage (facoltativo)",
	"Storage configuration missing": "Configurazione dello spazio di archiviazione mancante",
	"Storage ready": "Spazio di archiviazione pronto",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Archiviare, ricercare, analizzare, monitorare e inviare avvisi per dati di log ed eventi IBM Cloud.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "stato di esito positivo",
	"Success! This promotion was applied to your account.": "Operazione riuscita. Questa promozione è stata applicata al tuo account.",
	"Successfully created new Key Protect instance": "Creata con successo una nuova istanza Key Protect",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Piano di supporto",
	"Switch to folders view": "Passa alla vista cartelle",
	"Switch to objects view": "Passa alla vista oggetti",
	Sydney: Sydney,
	"Syntax: ": "Sintassi: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "Non è stato possibile creare la tag '{{tagName}}' perché il nome non è valido.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Tag:",
	"Tags: (optional)": "Tag: (facoltativo)",
	"Tall (64px)": "Alta (64px)",
	"Target destination": "Target di destinazione",
	"Target location": "Ubicazione di destinazione",
	"Target name": "Nome di destinazione",
	"Target selected": "Destinazione selezionata",
	"Target service instance": "Istanza servizio di destinazione",
	"Target type": "Tipo di destinazione",
	"Template error": "Errore di modello",
	"Terms and conditions": "Termini e condizioni",
	"Test notification": "Notifica di prova",
	"The address field is required.": "Il campo indirizzo è obbligatorio.",
	"The catalog window might have been blocked from opening.": "L'apertura della finestra del catalogo potrebbe essere stata bloccata.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "L'istanza di Event Notifications connessa è stata eliminata dall'account. Per continuare ad utilizzare le notifiche, disconnettere l'istanza corrente facendo clic su Disconnetti dal menu ( ⋮ ). Quindi, connettere un'altra istanza di Event Notifications.",
	"The description should not contain any leading or trailing whitespace characters.": "La descrizione non deve contenere spazi iniziali o finali.",
	"The description should not exceed {{limit}} characters in length.": "La descrizione non deve superare i {{limit}} caratteri di lunghezza.",
	"The following access is required:": "È richiesto il seguente accesso:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "La seguente anteprima del codice visualizza la richiesta corrispondente come comandi CLI. Utilizzarla come punto di partenza per scrivere la propria automazione. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "La seguente anteprima del codice visualizza la richiesta corrispondente come chiamate API REST. Utilizzarla come punto di partenza per scrivere la propria automazione. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "La seguente anteprima del codice visualizza la richiesta corrispondente con Terraform. Utilizzarla come punto di partenza per scrivere la propria automazione. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "La seguente anteprima visualizza la richiesta corrispondente come codice. Utilizzarla come punto di partenza per scrivere la propria automazione.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "Le seguenti risorse non sono state incluse nella stima dei costi ma potrebbero avere un costo associato.",
	"The IAM role manager for {{serviceName}}": "Il gestore di ruoli IAM per {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "Non è possibile accedere all'istanza perché un'autorizzazione service-to-service è stata rimossa dall'account. Creare un'autorizzazione con accesso a Event Source Manager tra {{sourceServiceName}} e Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "Impossibile popolare l'elenco degli spazi dei nomi. Riprova più tardi.",
	"The list of projects can't be populated. Try again later.": "Impossibile popolare l'elenco dei progetti. Riprova più tardi.",
	"The name is required.": "Il nome è obbligatorio.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "Il nome deve essere composto da un massimo di {{max}} caratteri, iniziare con una lettera e contenere solo caratteri alfanumerici, '-' e '.'",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Il nome di uno spazio dei nomi può includere solo lettere minuscole, numeri e trattini. Il nome non può iniziare o terminare con un trattino e deve avere un massimo di 63 caratteri.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Il nome di un progetto può includere solo lettere minuscole, numeri e trattini. Il nome non può iniziare o terminare con un trattino e deve avere un massimo di 63 caratteri.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "Il nome deve contenere solo caratteri alfanumerici, caratteri di sottolineatura, trattini e spazi.",
	"The name should not contain any special characters.": "Il nome non deve contenere caratteri speciali.",
	"The name should not exceed {{limit}} characters in length.": "Il nome non deve superare i {{limit}} caratteri di lungezza.",
	"The region is required.": "La regione è obbligatoria.",
	"The resource group is required.": "Il gruppo di risorse è obbligatorio.",
	"The resource group window might have been blocked from opening.": "L'apertura della finestra del gruppo di risorse potrebbe essere stata bloccata.",
	"The tag name must be in a key:value format": "Il nome della tag deve essere in formato chiave:valore",
	"The tag name must be in a key:value format.": "Il nome del tag deve essere in un formato chiave: valore.",
	"The window might have been blocked from opening.": "L'apertura della finestra potrebbe essere stata bloccata.",
	"There was a problem loading resource groups.": "Si è verificato un problema durante il caricamento dei gruppi di risorse.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "Questi ruoli consentono di accedere utilizzando il servizio ed eseguendo le chiamate API al servizio. Ogni ruolo viene personalizzato dal servizio selezionato. Selezionare tutte le opzioni appropriate. Per ulteriori dettagli, fai riferimento alla documentazione del servizio.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "Questi ruoli vengono creati dagli amministratori nell'account per personalizzare come viene assegnato l'accesso al servizio. Fai clic sull'icona Azioni per il ruolo per controllare quali azioni sono associate a questo ruolo.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "Questi ruoli consentono l'esecuzione di azioni sulle risorse della piattaforma, come la creazione di un'istanza, la connessione delle istanze alle applicazioni e l'assegnazione dell'accesso utente. Selezionare tutte le opzioni appropriate.",
	"This field is required": "Questo campo è obbligatorio",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "Attualmente non viene inviato all'inoltro ed è in attesa di un aggiornamento dal team responsabile per l'API.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "Questo è il modo in cui l'istanza {{serviceName}} è referenziata in Event Notifications",
	"This project name \"{{name}}\" already exists, please choose another name.": "Il nome di questo progetto \"{{name}}\" esiste già, scegliere un altro nome.",
	"This section is under construction, come back later.": "Questa sezione è attualmente in costruzione, ritornare più tardi.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "Questo servizio richiede spazio di archiviazione aggiuntivo assegnato al cluster. Non esiste alcuna configurazione di spazio di archiviazione corrispondente.",
	"This tag already exists. Choose another name for your tag.": "Questa tag già esiste. Scegli un altro nome per la tua tag.",
	"This value already exists.": "Questo valore esiste già.",
	"This view is not available for some account types": "Questa vista non è disponibile per alcuni tipi di account",
	"Three zone names are required": "Sono richiesti tre nomi zona",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "Per aggiungere la crittografia HPCS, procedere come segue:",
	"To connect, the instance in this region must be configured for platform": "Per connettersi, l'istanza in questa regione deve essere configurata per la piattaforma",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "Per controllare le notifiche degli eventi generati da {{serviceName}}, collegarsi ad un'istanza di Event Notifications. <a>Ulteriori informazioni</a>",
	"To create a new HPCS key, follow the steps below...": "Per creare una nuova chiave HPCS, procedere come segue...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Account totali",
	"Total estimated cost": "Costo totale stimato",
	"Transaction ID": "ID transazione",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Riprovare più tardi o contattare l'amministratore dell'account.",
	"Try again later.": "Riprova più tardi.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Provare ad aggiornare la pagina ed eseguire di nuovo l'azione per verificare se il problema persiste. In tal caso, assicurarsi di utilizzare un <a>browser supportato</a> e controllare la <a>pagina dello stato</a> per vedere se sta succedendo qualcos'altro. Se continui a riscontrare dei problemi, contatta il <a>supporto</a> per assistenza.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Prova ad attendere qualche minuto ed esegui di nuovo l'azione per vedere se il problema persiste. In tal caso, controlla la <a>pagina dello stato</a> per appurare se si sta verificando qualche altra condizione. Se continui a riscontrare dei problemi, contatta il <a>supporto</a> per assistenza.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Digitare \"{{clusterName}}\" per confermare",
	"Type \"{{name}}\" to confirm": "Immettere \"{{name}}\" per confermare",
	"Unable to configure activity tracker event routing.": "Non è stato possibile configurare il routing degli eventi di activity tracker",
	"Unable to configure Activity Tracker integration.": "Non è stato possibile configurare l'integrazione Activity Tracker.",
	"Unable to configure Logging integration.": "Non è stato possibile configurare l'integrazione della registrazione.",
	"Unable to configure logging.": "Non è stato possibile configurare la registrazione.",
	"Unable to connect your service to Event Notifications service. Try again later.": "Impossibile connettere il proprio servizio al servizio Event Notifications. Riprova più tardi.",
	"Unable to create authorization policy.": "Impossibile creare la politica di autorizzazione.",
	"Unable to create Satellite location": "Impossibile creare l'ubicazione Satellite",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "Impossibile creare la politica da servizio a servizio in questo momento. Aggiorna la pagina o riprova più tardi.",
	"Unable to delete cluster": "Non è stato possibile eliminare il cluster",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Impossibile disconnettere l'istanza Event Notifications. Aggiorna la pagina o riprova più tardi.",
	"Unable to get cluster data": "Impossibile ottenere i dati del cluster",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Impossibile ottenere i dettagli dell'istanza Event Notifications. Aggiorna la pagina o riprova più tardi.",
	"Unable to get storage instances.": "Impossibile ottenere le istanze di memoria.",
	"Unable to list clusters.": "Impossibile elencare i cluster.",
	"Unable to list locations.": "Impossibile elencare le ubicazioni.",
	"Unable to load Activity Tracker service catalog data": "Non è stato possibile caricare i dati del catalogo dei servizi Activity Tracker",
	"Unable to load Cloud Logs service catalog data": "Non è stato possibile caricare i dati del catalogo dei servizi Cloud Logs",
	"Unable to load cluster details.": "Impossibile caricare i dettagli del cluster.",
	"Unable to load cluster update version options.": "Impossibile caricare le opzioni di aggiornamento versione del cluster.",
	"Unable to load event routing settings": "Non è stato possibile caricare le impostazioni di routing degli eventi",
	"Unable to load event routing target instances": "Non è stato possibile caricare le istanze di destinazione del routing degli eventi",
	"Unable to load event routing target instances.": "Non è stato possibile caricare le istanze di destinazione del routing degli eventi.",
	"Unable to load event routing targets": "Non è stato possibile caricare i target di routing degli eventi",
	"Unable to load event routing targets.": "Non è stato possibile caricare i target di routing degli eventi.",
	"Unable to load IBM Cloud locations data": "Non è stato possibile caricare i dati delle ubicazioni di IBM Cloud",
	"Unable to load logging instances": "Non è stato possibile caricare le istanze di registrazione",
	"Unable to load logging instances.": "Impossibile caricare le istanze di registrazione.",
	"Unable to load logging service catalog data": "Non è stato possibile caricare i dati del catalogo del servizio di registrazione",
	"Unable to load logs routing targets": "Non è stato possibile caricare i log dei target di routing",
	"Unable to load logs routing targets.": "Impossibile caricare le registrazioni dei target di routing.",
	"Unable to perform": "Impossibile eseguire",
	"Unable to retrieve cluster details": "Non è stato possibile recuperare i dettagli del cluster",
	"Unable to retrieve data": "Impossibile richiamare i dati",
	"Unable to retrieve location information.": "Impossibile richiamare le informazioni sull'ubicazione.",
	"Unable to retrieve project configurations.": "Non è stato possibile recuperare le configurazioni del progetto.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Impossibile inviare la notifica di test all'istanza Event Notifications. Riprova più tardi.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Impossibile inviare la notifica di test all'istanza Event Notifications. Verificare se gli argomenti sono impostati in Event Notifications.",
	"Unable to update cluster version.": "Impossibile aggiornare la versione del cluster.",
	Unknown: Unknown,
	"unknown state": "Stato sconosciuto",
	"Unselect all rows": "Deseleziona tutte le righe",
	"Unselect row": "Deseleziona riga",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Versione non supportata. Aggiorna la versione per continuare a ricevere supporto.",
	"Upcoming scheduled events in your timezone": "Prossimi eventi programmati nel proprio fuso orario",
	Update: Update,
	"Update available": "Aggiornamento disponibile",
	"Update cluster version": "Aggiorna versione del cluster",
	"Update tags": "Aggiorna tag",
	"Update version": "Versione di aggiornamento",
	"Updating...": "Aggiornamento in corso...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Esegui l'upgrade del tuo account per visualizzare il periodo di fatturazione.",
	"Usage based charges apply per gigabyte of audit events ingested.": "I costi basati sull'utilizzo si applicano per ogni gigabyte di eventi di audit ingeriti.",
	"Usage based charges apply per gigabyte of logs ingested.": "I costi basati sull'utilizzo si applicano per ogni gigabyte di registri ingeriti.",
	"Usage costs": "Costi di utilizzo",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Utilizzare un segreto per gestire in modo sicuro e centrale le credenziali per l'autenticazione. <a>Ulteriori informazioni</a>",
	"Use a secret?": "Utilizzare un segreto?",
	"Use existing": "Utilizza esistente",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Utilizzare gli alias chiave per identificare facilmente le chiavi. Un alias chiave è un nome personalizzato univoco e facilmente riconoscibile.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Utilizza le tag per organizzare le tue risorse. Se le tue tag utente sono correlate alla fatturazione, valuta la possibilità di scrivere le tag come coppie chiave:valore per aiutarti a raggruppare le tag correlate, come ad esempio",
	"Use the options below to choose the item that the reference will be created for.": "Utilizzare le opzioni riportate di seguito per scegliere l'elemento per cui verrà creato il riferimento.",
	"User evaluation required": "Valutazione utente richiesta",
	"User permissions failure": "Mancanza di autorizzazioni per gli utenti",
	"User tags": "Tag utente",
	"User tags (optional": "Tag utente (facoltativo",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "Le tag utente sono visibili a livello di account. Evita di includere dati sensibili nel nome della tag.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "Il valore deve essere un array valido (Es. [\"array\"]). Per specificare un array null utilizzare \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Verificare che i seguenti servizi siano stati installati nell'ubicazione: {{missingServices}}.",
	Version: Version,
	View: View,
	"View all": "Visualizza tutto",
	"View audit events": "Visualizzare gli eventi di audit",
	"View docs": "Visualizza la documentazione",
	"View error information": "Visualizza informazioni sull'errore",
	"View logging": "Visualizzare la registrazione",
	"View-only mode": "Modalità di sola visualizzazione",
	"VPC Gen1": "VPC Gen1",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "stato di avvertimento",
	"Washington DC": "Washington DC",
	Wednesday: Wednesday,
	"What you will need:": "Operazioni necessarie:",
	"What's the purpose of this project?": "Qual è lo scopo di questo progetto?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "Quando elimini il cluster, vengono eliminati in modo permanente tutti i nodi di lavoro, le applicazioni e i contenitori. Questa azione non può essere annullata. Prima di procedere, assicurati di aver eseguito il backup di tutti i file di configurazione e dei dati necessari.",
	"Worker count": "Conteggio nodi di lavoro",
	Workloads: Workloads,
	"Wrong Syntax": "Sintassi errata",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "Hai già un'ubicazione con questo nome. Immettere un nome univoco.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Si dispone già di un'istanza di Security and Compliance Center. Per visualizzare i risultati, è necessario pianificare la prima scansione creando un allegato.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "Non puoi modificare questa politica a causa del tuo livello di accesso alla risorsa della politica. Se vuoi avere la possibilità di modificare, contatta il tuo amministratore per aggiornare l'accesso alla risorsa.",
	"You can find a list of resources here once you create them.": "È possibile trovare un elenco di risorse qui una volta create.",
	"You can find your resource details here after you create them.": "E' possibile trovare i dettagli della tua risorsa qui dopo averli creati.",
	"You can find your resources here after you create them.": "È possibile trovare le proprie risorse qui dopo averle create.",
	"You can find your Satellite locations here after you create them.": "Puoi trovare le tue ubicazioni del satellite qui dopo averle create.",
	"You do not have access to any resource groups.": "Non hai accesso ad alcun gruppo di risorse.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "Non hai accesso ad alcun gruppo di risorse. <a>Creare</a> un gruppo di risorse.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "Non si dispone dell'autorizzazione per modificare i tag. Contattare l'amministratore se è necessario un accesso più ampio.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "Non si dispone dell'accesso corretto per aggiungere una configurazione in \"{{project}}\"",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "Si dispone di un accesso limitato e potrebbe non essere possibile aggiungere o rimuovere tag. Contattare l'amministratore se è necessario un accesso più ampio.",
	"You haven't connected an Event Notifications service instance yet.": "Non è ancora stata connessa un'istanza del servizio Event Notifications.",
	"You may also <a>create an instance</a>.": "Puoi anche <a>creare un'istanza</a>.",
	"You may also create a new one.": "È possibile anche crearne uno nuovo.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "È possibile che siano abilitate limitazioni basate sul contesto o politiche IAM. Contattare l'amministratore dell'account.",
	"You must have at least one active root key. Try creating a new one.": "È necessario avere almeno una chiave root attiva. Provate a crearne uno nuovo.",
	"You need at least 1 topic to send a test notification.": "È necessario almeno 1 argomento per inviare una notifica di prova.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "Hai bisogno del ruolo di editor o di amministratore sul servizio dei Progetti IBM Cloud per questo progetto. <a>Assegnati l'accesso</a> o richiedi l'accesso all'amministratore dell'account.",
	"You're adding tags to:": "Stai aggiungendo delle tag a:",
	"You're editing tags for:": "Stai modificando le tag per:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "Non si è autorizzati a connettersi a questa istanza. Verificare le autorizzazioni o contattare l'amministratore.",
	"You're using the newest version of the API server. There are no updates available at this time.": "Stai utilizzando la versione più recente del server API. Non ci sono aggiornamenti disponibili in questo momento.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "Hai raggiunto il numero massimo di tag che puoi collegare in una sola volta. Per collegare più tag, salva prima le tue modifiche.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Il server API si sta aggiornando alla versione {{version}}. Al termine, è possibile aggiornare i nodi di lavoro alla stessa versione.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Ingrandisci immagine",
	"Zoom out image": "Riduci immagine"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, it as default, hour, hr, mo, more, provided, region, resources, tag, tags };
